import { render, staticRenderFns } from "./FinishScreen.vue?vue&type=template&id=6ecc3fa4&scoped=true"
import script from "./FinishScreen.vue?vue&type=script&lang=js"
export * from "./FinishScreen.vue?vue&type=script&lang=js"
import style0 from "./FinishScreen.vue?vue&type=style&index=0&id=6ecc3fa4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecc3fa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1702/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ecc3fa4')) {
      api.createRecord('6ecc3fa4', component.options)
    } else {
      api.reload('6ecc3fa4', component.options)
    }
    module.hot.accept("./FinishScreen.vue?vue&type=template&id=6ecc3fa4&scoped=true", function () {
      api.rerender('6ecc3fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/components-combo/FinishScreen.vue"
export default component.exports